import type { ReactNode } from 'react';
import { Select, type SelectOption } from '../primitives';

export interface DismissibleFilterProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  searchable?: boolean;
  /** Leading type-icon shown in the Select trigger. */
  icon?: ReactNode;
  /** Removes the filter from the bar (used when it has no value). */
  onDismiss: () => void;
  className?: string;
  /** Multi-select mode — forwarded to Select. */
  multiple?: boolean;
  values?: string[];
  onValuesChange?: (values: string[]) => void;
  /** Prefix shown once set ("Country: Japan"). */
  label?: string;
}

/**
 * A secondary filter surfaced from "+ More Filters". Thin wrapper over Select
 * using its single-action-slot clear/dismiss (licensing FilterChip pattern):
 * when the filter has a value the trigger's × clears it; when empty, × removes
 * the filter from the bar. One dropdown component across the whole filter bar.
 */
export function DismissibleFilter({
  options,
  value,
  onChange,
  searchable,
  icon,
  onDismiss,
  className,
  multiple,
  values,
  onValuesChange,
  label,
}: DismissibleFilterProps) {
  return (
    <Select
      label={label}
      highlightWhenSet
      options={options}
      value={value}
      onChange={onChange}
      searchable={searchable}
      icon={icon}
      dismissible
      onClear={onDismiss}
      className={className}
      multiple={multiple}
      values={values}
      onValuesChange={onValuesChange}
    />
  );
}
